


















import Vue from "vue"
import Word from "./Word"
import Colophon from "./Colophon"
import {EventBus} from "./eventbus"

export default Vue.extend({
  data() {
    return {
      numberOfWords: 2,
    }
  },
  components: {
    Word,
    Colophon,
  },
  methods: {
    inc: function() {
      if (this.numberOfWords < 5) {
        this.numberOfWords += 1
      }
    },
    dec: function() {
      if (this.numberOfWords > 2) {
        this.numberOfWords -= 1
      }
    },
    rando: function() {
      EventBus.$emit('randomise')
    }
  }
})
